<template>
    <div class="p-6 text-center">
        <base-svg
            :name="is_verified ? 'illustration-mobile-tick' : 'illustration-empty'"
            class="w-full mx-auto mb-6 max-w-2xs"
        />

        <h6 class="mb-3 text-lg font-normal font-semibold">
            {{ is_verified ? 'Telephone confirmed!' : 'Link expired!' }}
        </h6>

        <div class="text-grey-darker">
            <p v-if="is_verified">
                We'll start sending you notifications via SMS, according to your
                notification preferences.
            </p>

            <p v-else>
                We were unable to confirm your telephone number as the link you used
                has expired.
            </p>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        computed: {
            is_verified () {
                return _.preload('is_verified', false)
            }
        }
    }
</script>
